import React from 'react';

import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import { Link } from 'react-router-dom';

class GuestPage extends React.Component {

    constructor(props) {
        super(props);

        this.props.updateLoader({
            loaded: true,
            message: ""
        });
    }

    render() {
        return (
            <div>
                <h4 className="mb-4">Ограничение доступа</h4>

                <div className="alert alert-warning" role="alert">
                    Для работы с системой необходимо выполнить <Link to="/users/login">вход</Link>.
                </div>
                <div className="alert alert-info" role="alert">
                    Если вы попали сюда после попытки совершить какое-либо действие - срок действия вашего токена доступа истёк, необходимо авторизоваться заново.
                </div>
            </div>
        );
    }
}

export default GuestPage;